/**
 * useDocumentTitle — set the browser tab title from any React tree.
 *
 * Rule (see /app/design_guidelines.md § 8):
 * Every tabbed dashboard (InstituteHub, AdminPastoralTools, …) and every
 * routed page whose meaning changes with a query param or inner state
 * must reflect that state in `document.title`. Uniform format:
 *
 *     "{contextual label} · {suffix}"
 *
 * where `suffix` is the short brand tag ("Instituto REC" / "RIC Institute"
 * / "Concilio A" / "REC Admin"). The hook restores the previous title on
 * unmount so leaving the page is clean and no title leaks.
 *
 * Usage:
 *   useDocumentTitle(`${tabLabel} · ${suffix}`);
 *
 * The hook is intentionally minimal (no dependencies, no context) so it
 * can drop into any page without ceremony.
 */
import { useEffect } from "react";

export default function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
